<template>
  <div class="login">
    <h2>用户登录</h2>
    <div class="login_box">
      <div class="input_box">
        <span>手机：</span>
        <div class="ins">
        <input class="comm_input" placeholder="手机号" type="text" v-model="mobile" />
        </div>
      </div>
      <div class="input_box marb0">
        <span>密码：</span>
        <div class="ins">
          <input class="comm_input"  placeholder="密码" type="password" v-model="password" />
        </div>
      </div>
      <div class="input_box">
        <span></span>
        <div class="ins">
         <p  @click="$router.push({path: 'regist'})">没有账号？注册一个吧</p>
        </div>
      </div>
      <div class="input_btn">
        <span></span>
        <button class="sub_btn co_bth" @click="login">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../vuex/store'
    export default {
        name:'Login',
        data() {
            return {
                mobile: "",
                password: "",
            };
        },
        methods: {
            validateMobile(mobile) {
                return /1(3|4|5|6|7|8|9)\d{9}/.test(mobile)
            },
            check_other_char(str) {
                var arr = ["&", "\\", "/", "*", ">", "<", "@", "!"];
                for (var i = 0; i < arr.length; i++)
                {
                    for (var j = 0; j < str.length; j++)
                    {
                        if (arr[i] == str.charAt(j))
                        {
                            return true;
                        }
                    }
                }
                return false;
            },
            login() {
                if (!this.mobile) {
                    alert("请填写账号");
                    return;
                }
                if (!this.password) {
                    alert("请输入密码");
                    return;
                }
                if(this.password&&this.mobile){
                    if (!this.validateMobile(this.mobile)){
                        alert('手机号码格式不正确')
                    }
                    else {
                        this.$axios({
                            url:'https://api.hainanfa.org.cn/guess/login',
                            method:'post',
                            params:{
                                mobile:this.mobile,
                                password: this.password
                            },
                            headers:{
                                'Content-Type':'application/json;charset=utf-8'
                            }
                        }).then(res=>{
                            console.log(res);
                            store.dispatch("userId", res.data.data.id);
                            localStorage.setItem("id", res.data.data.id);
                            alert('登录成功！')
                            this.$router.replace('/list')
                        }).catch(err=>{
                            console.log(err);
                            alert('请验证你输入的手机号或者密码')
                        })
                    }
                }
            }
        }
    };
</script>
<style scoped>
  .login{
    padding: 40px 10px;
  }
  .login h2{
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    color: #000000;
    margin: 24px 0;
  }
  .login_box{
    height: 200px;
  }
  .login_box .input_box{
    display: flex;
    align-items: center;
    margin-bottom: 24px;
  }
  .input_box span{
    flex: 0 0 70px;
    text-align: right;
    padding-right: 12px;
  }
  .ins{
    width: 100%;
  }
  .ins p{
    font-size: 12px;
    color: #666666;
    line-height: 1.5em;
    margin-top: 12px;
  }
  .input_btn{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .input_btn span{
    flex: 0 0 70px;
  }
  .login_box .marb0{
    margin-bottom: 0;
  }
</style>
